import styled from 'styled-components';

export const GradualQuestionSlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  overflow: auto;
`;

export const QuestionContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const QuestionGroup = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: var(--ion-color-primary);
  margin-bottom: 10px;
  text-transform: capitalize;
`;

export const QuestionText = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-dark);
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;

  &.no-response {
    border-top: none;
  }

  & .btn-navigate {
    flex: 1;
    max-width: 50%;
  }

  & .btn-navigate-disabled {
    flex: 1;
    max-width: 50%;
    opacity: 0;
    user-select: none;
    pointer-events: none;
  }
`;
